import Buefy from 'buefy';
import Vue from 'vue';
import Vui from '@beanfield/vui';

Vue.use(Vui);
Vue.use(Buefy);
